import { Button } from 'components/Button'
import Link from 'next/link'
import { useTranslation } from 'hooks/useTranslation'
import { AllProductsRoot } from './AllProducts.styles'
import { SectionTitle } from '../../Treats.styles'

export const AllProducts = () => {
  const { t } = useTranslation()

  return (
    <AllProductsRoot>
      <SectionTitle>{t('products:startr.viewAll.title')}</SectionTitle>
      <Link href="/products">
        <Button>{t('products:startr.viewAll.cta')}</Button>
      </Link>
    </AllProductsRoot>
  )
}
